/**
 * @desc ebs结果返回请求接口
 */
const URL = "/rantion-bus";
import http, { updateResponse } from "@/http";
export function request(body: defs.bus.EbsFeedBackRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/exchange/ebsFeedBack`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
